import PropTypes from 'prop-types';
import React from 'react';

// components
import DealMakingModalBase, { modalStyles, EventLinkStyled } from './DealMakingModalBase';
import ModalBase from '@molecules/ModalBase';

const NY_EVENT_CODE = '2026NY';
const NY_DISPLAY_NAME = 'ICSC NEW YORK, December 9-10, 2026';

const NY_FINE_PRINT = `* Offer valid for select ICSC Members in good standing. Offer is non-transferable. Additional terms and conditions may apply. Offer valid for ${NY_DISPLAY_NAME} only. Limit (1) one single use discount per person.`;

const NY_AND_DEALMAKING_FINE_PRINT =
    '* Offer valid for select ICSC Members in good standing to attend ICSC NEW YORK and/or one (1) of the eligible ICSC@ dealmaking events through February 28, 2027. Limit one (1) single-use discount per event type, per person. Offer is non-transferable. Additional terms and conditions may apply.';

const getNyMessage = onClose => (
    <>
        You&apos;ve been selected to receive 50% off your registration for{' '}
        <EventLinkStyled href="/2026NY" onClick={onClose}>{NY_DISPLAY_NAME}</EventLinkStyled>
    </>
);

const NY_AND_DEALMAKING_MESSAGE = (
    <>
        Register for {NY_DISPLAY_NAME} and/or a regional dealmaking event of your choosing
    </>
);

const DEALMAKING_MESSAGE = (
    <>
        You&apos;ve been selected to receive 50% off a regional dealmaking event listed below. *
        <br />
    </>
);

const DealMakingModal = ({ isOpen, events, onClose }) => {
    if (!events || events.length === 0) {
        return null;
    }

    const nyEvent = events.find(e => e.code === NY_EVENT_CODE);
    const dealMakingEvents = events.filter(e => e.code !== NY_EVENT_CODE);

    const hasNY = !!nyEvent;
    const hasDealMaking = dealMakingEvents.length > 0;

    // Scenario 2: only dealmaking events — existing behavior, no changes
    if (hasDealMaking && !hasNY) {
        return (
            <ModalBase
                isOpen={isOpen}
                shouldCloseOnOverlayClick={true}
                stylesBody={modalStyles.body}
                stylesContent={modalStyles.content}
                stylesOverlay={modalStyles.overlay}
                onClose={onClose}
            >
                <DealMakingModalBase
                    heading="Receive 50% Off Your Registration"
                    message={DEALMAKING_MESSAGE}
                    events={dealMakingEvents}
                    onClose={onClose}
                />
            </ModalBase>
        );
    }

    // Scenario 1: only 2026NY — inline link in message, no event list
    if (hasNY && !hasDealMaking) {
        return (
            <ModalBase
                isOpen={isOpen}
                shouldCloseOnOverlayClick={true}
                stylesBody={modalStyles.body}
                stylesContent={modalStyles.content}
                stylesOverlay={modalStyles.overlay}
                onClose={onClose}
            >
                <DealMakingModalBase
                    heading="Receive 50% Off Your Registration"
                    message={getNyMessage(onClose)}
                    events={[]}
                    finePrint={NY_FINE_PRINT}
                    onClose={onClose}
                />
            </ModalBase>
        );
    }

    // Scenario 3: both 2026NY and dealmaking events
    return (
        <ModalBase
            isOpen={isOpen}
            shouldCloseOnOverlayClick={true}
            stylesBody={modalStyles.body}
            stylesContent={modalStyles.content}
            stylesOverlay={modalStyles.overlay}
            onClose={onClose}
        >
            <DealMakingModalBase
                heading="Receive 50% Off Your Registrations"
                message={NY_AND_DEALMAKING_MESSAGE}
                events={[{ ...nyEvent, title: NY_DISPLAY_NAME }, ...dealMakingEvents]}
                separatorAfter={1}
                finePrint={NY_AND_DEALMAKING_FINE_PRINT}
                checkoutText="Register today and your discount(s) will be applied automatically at check out."
                onClose={onClose}
            />
        </ModalBase>
    );
};

DealMakingModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    events: PropTypes.arrayOf(
        PropTypes.shape({
            code: PropTypes.string,
            title: PropTypes.string,
        })
    ).isRequired,
    onClose: PropTypes.func.isRequired,
};

export default DealMakingModal;
